
import React, {createContext, useContext, useRef, useState} from 'react';
//import {toast} from 'react-hot-toast';
//import useLocalStorage from '../hooks/useLocalStorage';
import { useLocalContextStorage } from '../hooks/useLocalStorage';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from './AuthContext';
import { isGodMode } from '../utils/permissions';

const Context = createContext();

export const StateContext = ({children}) => {
    const { user } = useAuthContext(AuthContext)
     
    //process.env.NODE_ENV === "development" && console.log("user", user) 
    const [project, setProject ] = useLocalContextStorage("project")
    const [showSidebar, setShowSidebar] = useState(false)
    const apiUrl = process.env.NODE_ENV === 'development' 
                    ? 'http://localhost:4000' :
                      process.env.NODE_ENV === 'production' ?
                        process.env.REACT_APP_BACKEND_URL : undefined
    const [language, setLanguage] = useState(undefined) // language
    const screenLog = useRef("")
    const [surveyResponseDoc, setSurveyResponseDoc] = useLocalContextStorage("surveyResponseDoc")
    const [newSurvey, setNewSurvey] = useLocalContextStorage("newSurvey")
    const [journalEntry, setJournalEntry] = useLocalContextStorage("journalEntry")
    const [concert, setConcert] = useLocalContextStorage("concert")
    const [myMindPro, setMyMindPro] = useLocalContextStorage("myMindPro")
    const [rawAiConcert, setRawAiConcert] = useLocalContextStorage("rawAiConcert")
    const [activeConcertLogs, setActiveConcertLogs] = useLocalContextStorage("activeConcertLogs")
    const [songLogs, setSongLogs] = useLocalContextStorage("songLogs")
    const [bookRemind, setBookRemind] = useLocalContextStorage("bookRemind")

    const customLog = (...args) => {
      let strings = [];

      for (let i = 0; i < args.length; i++) {
        const stringified = JSON.stringify(args[i], null, 2); // pretty print (optional)
        process.env.NODE_ENV === "development" &&  console.log(stringified);
        strings.push(stringified);
      }

      screenLog.current = strings;
      
      // Dispatch a custom event that ScreenLogger can listen for
      const event = new CustomEvent('screenLogUpdated', { detail: strings });
      document.dispatchEvent(event);
    };  
   
    const hideTestButtons = isGodMode(user) ? false : true
  return (
    <Context.Provider
    value={{
        project, setProject,
        showSidebar, setShowSidebar,
        language, setLanguage,
        surveyResponseDoc, setSurveyResponseDoc,
        concert, setConcert,
        journalEntry, setJournalEntry,
        myMindPro, setMyMindPro,
        rawAiConcert, setRawAiConcert,
        newSurvey, setNewSurvey,
        activeConcertLogs, setActiveConcertLogs,
        songLogs, setSongLogs,
        bookRemind, setBookRemind,
        screenLog, customLog,
        hideTestButtons,
        apiUrl
    }}
    > {children} </Context.Provider>
  )
}

export const useStateContext = () => useContext(Context);
